import { render, staticRenderFns } from "./orderHistory.vue?vue&type=template&id=4f8be49a&scoped=true&"
import script from "./orderHistory.vue?vue&type=script&lang=js&"
export * from "./orderHistory.vue?vue&type=script&lang=js&"
import style0 from "./orderHistory.vue?vue&type=style&index=0&id=4f8be49a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8be49a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f8be49a')) {
      api.createRecord('4f8be49a', component.options)
    } else {
      api.reload('4f8be49a', component.options)
    }
    module.hot.accept("./orderHistory.vue?vue&type=template&id=4f8be49a&scoped=true&", function () {
      api.rerender('4f8be49a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/components/orderHistory.vue"
export default component.exports